// extracted by mini-css-extract-plugin
export default {"wave":"Yc7QQa","heroImageContainer":"WcqZfW","section":"STRwpA","image":"LcBXod","limitedOffer":"GNH_oC","hero":"QN4U8a","multiTreatHeight":"AI9oc_"};